import { render, staticRenderFns } from "./Estabelecimentos.vue?vue&type=template&id=0da631ac&"
import script from "./Estabelecimentos.vue?vue&type=script&lang=js&"
export * from "./Estabelecimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports